// import * as React from 'react';
// import { Component, PropTypes } from '../../libs';

function TableColumn() {
  return null;
}

TableColumn.typeName = 'TableColumn';

export default TableColumn;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/table/TableColumn.js
// module id = 460
// module chunks = 0